import React, { useState } from 'react';
import DriverActionsMenu from '../actions/DriverActionsMenu';

const DriverCard = ({ drivers, handleEdit, onDownload, onToggleStatus }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="grid gap-4 md:hidden">
        {drivers.map((driver, idx) => (
            <div key={idx} className="border rounded shadow p-4 bg-white">
            <div className="flex justify-between items-start gap-4">
                {/* Left: Driver info */}
                <div className="flex-1">
                <p className="font-semibold">{u(driver.name)}</p>
                <p className="text-sm text-gray-600">{driver.phone}</p>
                <p className="text-sm text-gray-600">{u(driver.email)}</p>
                <p className="text-xs text-gray-400">{u(driver.driver_code)}</p>

                <div className="mt-2 text-sm space-y-1">
                    <div>AADHAR: {u(driver.aadhar_number)}</div>
                    <div>LICENCE: {u(driver.licence_number)}</div>
                    <div>PAN: {u(driver.pan_number)}</div>
                </div>

                <div className="mt-2">
                    <span
                    onClick={() => onToggleStatus(driver)}
                    className={`cursor-pointer font-medium ${driver.active ? 'text-green-600' : 'text-red-500'}`}
                    >
                    {driver.is_active ? 'ACTIVE' : 'INACTIVE'}
                    </span>
                </div>
                </div>

                {/* Right: Action buttons */}
                <div className="flex flex-col items-end gap-1">
                <DriverActionsMenu
                    driver={driver}
                    onEdit={() => handleEdit(driver)}
                    onDownload={(type) => onDownload(driver, type)}
                />
                </div>
            </div>
        </div>
        ))}
    </div>
  );
};

export default DriverCard;
